<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="secondary" v-b-tooltip.hover :title="showToolTip ? 'Отменить' : ''"><i class="fa fa-ban"></i></b-button>
</template>

<script>

export default ({
  name: "button-cancel",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
